var exports = {
  "i": "xaf9ae18d--188586--wrapper",
};

module.exports = exports;
